import { Tag } from 'primereact/tag';
import { useTranslation } from 'react-i18next';

import {
  CertificatePermissionReviewStatus,
  RequestReviewStatus,
} from '../../../../shared/interfaces/ICertificate';
import styles from './SupplierCertificateReviewStatusTag.module.css';

type SupplierCertificateReviewStatusTagProps = {
  status?: CertificatePermissionReviewStatus | RequestReviewStatus;
};

const SupplierCertificateReviewStatusTag = ({
  status,
}: SupplierCertificateReviewStatusTagProps): JSX.Element | null => {
  const { t } = useTranslation();

  const getConfig = (): { className: string; text: string } | null => {
    switch (status) {
      case CertificatePermissionReviewStatus.ACCEPTED:
        return {
          className: styles['accepted-tag'],
          text: t('certificatesPage.tabs.supplierCertificatesTab.reviewStatuses.accepted'),
        };
      case CertificatePermissionReviewStatus.REJECTED:
        return {
          className: styles['rejected-tag'],
          text: t('certificatesPage.tabs.supplierCertificatesTab.reviewStatuses.rejected'),
        };
      case RequestReviewStatus.REQUESTED:
        return {
          className: styles['awaiting-supplier-tag'],
          text: t('certificatesPage.tabs.supplierCertificatesTab.reviewStatuses.requested'),
        };
      // When consumerReviewStatus is not there, it is actively pushed by the
      // provider and not yet reviewed by the consumer. Show "Pending" in this case.
      case RequestReviewStatus.PENDING:
      case undefined:
      case null:
        return {
          className: styles['needs-review-tag'],
          text: t('certificatesPage.tabs.supplierCertificatesTab.reviewStatuses.pending'),
        };

      default:
        return null;
    }
  };

  const config = getConfig();

  if (!config) {
    return null;
  }

  return (
    <Tag rounded className={`text-sm font-medium px-2 py-1 ${config.className}`}>
      <span className='text-center flex'>{config.text}</span>
    </Tag>
  );
};

export default SupplierCertificateReviewStatusTag;
